import { useEffect } from 'react';

function Modal({ open, onClose, title, wide, resizable, children, panelRef, panelStyle }) {
    // Manage body overflow when modal opens/closes
    useEffect(() => {
        if (open) {
            // Save current scroll position
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
            document.body.style.marginRight = '0'; // Prevent layout shift

            return () => {
                // CRITICAL: Restore on unmount or close
                document.body.style.overflow = '';
                document.body.style.marginRight = '';
                window.scrollTo(0, scrollTop);
            };
        }
    }, [open]);

    if (!open) return null;

    const panelClass = [
        'modal__panel',
        wide && 'modal__panel--wide',
        resizable && 'modal__panel--resizable'
    ].filter(Boolean).join(' ');

    // Handle backdrop click - only close if clicking directly on backdrop
    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal" role="dialog" aria-modal="true" onClick={handleBackdropClick}>
            <div
                className={panelClass}
                onClick={(event) => event.stopPropagation()}
                ref={panelRef}
                style={panelStyle}
            >
                <div className="modal__head">
                    <h3>{title}</h3>
                    <button type="button" className="ghost" onClick={onClose}>
                        Закрыть
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}

export default Modal;
